import Color from 'color';
import styled, {css} from 'styled-components';

import {getColor, ms} from '../../../../styles';
import {Clickable} from '../../../../uikit/Clickable';
import {Text} from '../../../../uikit/Text';
import {View} from '../../../../uikit/View';
import {platform} from '../../../../utils/platform';

export const Container = styled(View)`
  flex-direction: row;
  border-radius: ${ms(10)};
  background-color: ${getColor('background2')};
  padding-inline: ${ms(6)} ${ms(6)};
  padding-block: ${ms(5)} ${ms(5)};
`;

export const Tab = styled(Clickable)<{isSelected: boolean}>`
  display: flex;
  justify-content: center;
  flex: 1 1 0;
  padding-block: ${ms(5)} ${ms(5)};
  border-radius: ${ms(7)};

  ${p =>
    p.isSelected &&
    css`
      background-color: ${getColor('background1')};
    `};

  ${p =>
    platform.isWeb &&
    p.isSelected &&
    css`
      box-shadow:
        0 8px 10px -9px ${Color(getColor('border5')(p)).alpha(0.55).toString()},
        0 4px 10px ${Color(getColor('border5')(p)).alpha(0.2).toString()};
    `};
`;

export const TabTitle = styled(Text).attrs({weight: 'semibold'})<{
  isSelected: boolean;
}>`
  text-align: center;
  color: ${p => getColor(p.isSelected ? 'text1' : 'text3')(p)};
`;
